export default __webpack_public_path__ + "static/media/White.3cd30fbc.jpg";